import React, { useRef, useState } from "react";
import {
  Box,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { useSession } from "../state/useSession";
import { useFileUpload } from "../hooks/useFileUpload";

const ACCEPT = ".csv,.xlsx,.xls";

function FileUploader({ onUploaded, onDone }) {
  const { hasFile, sourceFileName } = useSession();
  const { handleFiles } = useFileUpload({ onUploaded, onDone });
  const inputRef = useRef(null);
  const [dragging, setDragging] = useState(false);

  const onDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    handleFiles(e.dataTransfer.files);
  };

  return (
    <Box>
      {hasFile && (
        <Flex bg="gray.50" borderRadius="md" p={3} mb={3} justify="space-between">
          <Text fontSize="sm" fontWeight="medium">
            {sourceFileName}
          </Text>
          <Text fontSize="xs" color="gray.500">
            Current file
          </Text>
        </Flex>
      )}
      <Box
        borderWidth="2px"
        borderStyle="dashed"
        borderRadius="lg"
        p={8}
        textAlign="center"
        cursor="pointer"
        borderColor={dragging ? "teal.500" : "gray.300"}
        bg={dragging ? "teal.50" : "transparent"}
        _hover={{ borderColor: "teal.400" }}
        onClick={() => inputRef.current?.click()}
        onDragOver={(e) => {
          e.preventDefault();
          setDragging(true);
        }}
        onDragLeave={() => setDragging(false)}
        onDrop={onDrop}
      >
        <input
          ref={inputRef}
          type="file"
          accept={ACCEPT}
          style={{ display: "none" }}
          onChange={(e) => handleFiles(e.target.files)}
        />
        {dragging ? (
          <Text fontSize="sm" color="teal.600">
            Drop the file here...
          </Text>
        ) : (
          <>
            <Text fontSize="sm" color="gray.600">
              Drag &amp; drop a CSV or Excel file, or click to browse
            </Text>
            <Text fontSize="xs" color="gray.400" mt={1}>
              Supports .csv, .xlsx, .xls (max 100MB)
            </Text>
          </>
        )}
      </Box>
    </Box>
  );
}

export function FileUploaderModal({ isOpen, onClose, onUploaded }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Upload Source File</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <FileUploader onUploaded={onUploaded} onDone={onClose} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default FileUploader;
